module.exports = __webpack_public_path__ + "static/img/yytx22.81a8c55.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx22.png
// module id = 801
// module chunks = 0